import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetInternalCommunicationByOrderInput } from './GetInternalCommunicationByOrderInput';
import { GetInternalCommunicationByOrderOutput } from './GetInternalCommunicationByOrderOutput';

export class GetInternalCommunicationByOrderService extends HttpServiceBase {

  handle = (input: GetInternalCommunicationByOrderInput): Promise<Result<GetInternalCommunicationByOrderOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<GetInternalCommunicationByOrderOutput>>(`${this.baseUrlSislogApi}/v2/internal-communication-log${parameters}`);
    return promise;
  }
}